import FetchService from "./FetchService";
export class SubscriptionService {
    static getSubscriptionInfo(subscriberAffiliationId, subscribeeAffiliationId, includeExpired = false, offset = 0, max = 0) {
        return FetchService.getPagedResponse("/aviso/subscription/managingProcessForSubscriptions", {
            subscriberAffiliationId,
            subscribeeAffiliationId,
            includeExpired,
            offset,
            max,
        });
    }
    static expireSubscriptions(subscriptionsToExpire) {
        return FetchService.post("/aviso/subscription/expireSubscriptionsByList", {
            subscriptionsToExpire,
        });
    }
}
